import { useState } from "react";
import Layout from "../../components/Layout/Layout";
import BreadCrumb from "../../components/BreadCrumb/Breadcrumb";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PersonalInformation from "./components/PersonalInformation";
import Resume from "./components/Resume";
import Renumeration from "./components/Renumeration";
// import Box from "@mui/material/Box";
// import useStyles from "./styles";

const Teacher = () => {
//   const classes = useStyles();
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Layout children={
      <>
        <BreadCrumb link_one="/teacher" link_one_name="Teacher" active="Euguene" description="See relevant information of employee" />
        <TabContext value={value}>
          <div className="tablist-container">
            <Tabs indicatorColor="none" className="overide-tablist" onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Profile" value="1" />
              <Tab label="Resume CV" value="2" />
              <Tab label="Renumeration Details" value="3" />
            </Tabs>
          </div>
          <TabPanel value="1" className="tabpanel-overide">
            <PersonalInformation />
          </TabPanel>
          <TabPanel value="2"><Resume /></TabPanel>
          <TabPanel value="3"><Renumeration /></TabPanel>
        </TabContext>
      </>
    }
    />
  );
};

export default Teacher;
